import { takeLatest, put, call } from 'redux-saga/effects';

import { listGrupoContaAgrareWhiteLabel } from '../service';
import {
  TABLE_GRUPO_CONTA_AGRARE_WHITE_LABEL,
  TABLE_GRUPO_CONTA_AGRARE_WHITE_LABEL_PENDING,
  TABLE_GRUPO_CONTA_AGRARE_WHITE_LABEL_SUCCESS,
  TABLE_GRUPO_CONTA_AGRARE_WHITE_LABEL_FAILURE
} from '../actionTypes';

function* sagaListGrupoContaAgrareWhiteLabel(action) {
  yield put({ type: TABLE_GRUPO_CONTA_AGRARE_WHITE_LABEL_PENDING })

  try {
    const table = yield call(listGrupoContaAgrareWhiteLabel, action.args)
    yield put({ type: TABLE_GRUPO_CONTA_AGRARE_WHITE_LABEL_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_GRUPO_CONTA_AGRARE_WHITE_LABEL_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListGrupoContaAgrareWhiteLabel() {
  yield takeLatest(TABLE_GRUPO_CONTA_AGRARE_WHITE_LABEL, sagaListGrupoContaAgrareWhiteLabel)
}